
import { defineComponent, SetupContext, PropType } from "vue";
import NativeClient from "@/client/native-client";
import { IngredientData } from "@/types/pantry";
import SelectingIngredientList from "@/components/common/SelectingIngredientList.vue";
import PantryIngredientEmptyView from "./PantryIngredientEmptyView.vue";
export default defineComponent({
  name: "PantryIngredientFoodView",
  components: {
    SelectingIngredientList,
    PantryIngredientEmptyView
  },
  props: {
    categoryName: {
      type: String,
      default: ""
    },
    data: {
      type: Array as PropType<IngredientData[]>,
      default: null,
      required: true
    },
    selectName: {
      type: String,
      default: "",
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const onSelectIngredient = (
      id: number,
      name: string,
      isSelect: boolean
    ) => {
      NativeClient.sendDebugLog(
        "PantryIngredientFoodView onSelectIngredient categoryName=" +
          props.categoryName +
          "ingredientId = " +
          id +
          ", name = " +
          name +
          ", isSelect = " +
          isSelect
      );
      context.emit("on-select", props.categoryName, id, name, isSelect);
    };
    const isEmpty = () => {
      NativeClient.sendDebugLog(
        "PantryIngredientFoodView isEmpty=" + JSON.stringify(props.data)
      );
      return !(props.data && props.data.length != 0);
    };
    const isShow = () => {
      NativeClient.sendDebugLog(
        "PantryIngredientFoodView selectName=" +
          props.selectName +
          " id=" +
          props.categoryName
      );
      return props.categoryName != "" && props.categoryName == props.selectName;
    };
    const getData = () => {
      return props.data ? props.data : null;
    };
    return {
      isEmpty,
      onSelectIngredient,
      isShow,
      getData
    };
  }
});
